import React from 'react';

interface WebPledgeCardProps {
  previousPledge: () => void;
  nextPledge: () => void;
  pledgeText: string;
  conversationIndex: number;
  maxlength: number;
}

const WebPledgeCard: React.FC<WebPledgeCardProps> = ({
  previousPledge,
  nextPledge,
  pledgeText,
  conversationIndex,
  maxlength,
}) => {
  const isFirst = conversationIndex === 0;
  const isLast = conversationIndex === maxlength - 1;

  return (
    <div className="web-pledge-card-container">
      <button
        type="button"
        className={`web-pledge-arrow-btn${isFirst ? ' disabled' : ''}`}
        onClick={previousPledge}
        disabled={isFirst}
        aria-label="Previous pledge">
        <svg
          className={`web-pledge-arrow-icon${isFirst ? ' disabled' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      <div className="web-pledge-text-card">
        <p className="web-pledge-text">{pledgeText}</p>
      </div>

      <button
        type="button"
        className={`web-pledge-arrow-btn${isLast ? ' disabled' : ''}`}
        onClick={nextPledge}
        disabled={isLast}
        aria-label="Next pledge">
        <svg
          className={`web-pledge-arrow-icon${isLast ? ' disabled' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  );
};

export default WebPledgeCard;
